"use strict";
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.XmentService = exports.USE_SEARCH_SNAPSHOT = exports.FOOTER_NAV_MOBILE = exports.FILTER_LOCATION_MOBILE = exports.SEARCH_HIDE_MOBILE_FILTER_BUTTON = exports.SEARCH_V4_REGIONAL_BOOST_XMENT_NAME = exports.SEARCH_REPLACE_LEGACY_BASE_SCORE = exports.SEARCH_SHOW_ONLINE_COUNT_XMENT_NAME = exports.SEARCH_FREE_ACCOUNT_SIGN_UP_TILE_XMENT_NAME = exports.SEARCH_LOCAL_BOOST_ACTUAL_COUNTRY_SPAIN_XMENT_NAME = exports.SEARCH_TRANSLATE_TOP_FRENCH_SEARCHES = exports.SEARCH_LOGGED_OUT_REC_XMENT = exports.SEARCH_LOGGED_IN_REC_XMENT = void 0;
exports.SEARCH_LOGGED_IN_REC_XMENT = "searchLoggedInRec";
exports.SEARCH_LOGGED_OUT_REC_XMENT = "searchLoggedOutRec";
exports.SEARCH_TRANSLATE_TOP_FRENCH_SEARCHES = "searchTranslateTopFrenchSearches";
exports.SEARCH_LOCAL_BOOST_ACTUAL_COUNTRY_SPAIN_XMENT_NAME = "searchLocalBoostActualCountrySpain";
exports.SEARCH_FREE_ACCOUNT_SIGN_UP_TILE_XMENT_NAME = "searchFreeAccountSignUpTile";
exports.SEARCH_SHOW_ONLINE_COUNT_XMENT_NAME = "searchShowOnlineCount";
exports.SEARCH_REPLACE_LEGACY_BASE_SCORE = "searchReplaceLegacyBaseScore";
exports.SEARCH_V4_REGIONAL_BOOST_XMENT_NAME = "searchV4RegionalBoost";
exports.SEARCH_HIDE_MOBILE_FILTER_BUTTON = "searchHideMobileFilterButton";
exports.FILTER_LOCATION_MOBILE = "filter_location_mobile";
exports.FOOTER_NAV_MOBILE = "footer_nav_mobile";
// NOTE: this is not a real xment. It's meant as an integ toggle to be able to flip between snapshot and real data
exports.USE_SEARCH_SNAPSHOT = "useSearchSnapshot";
var XmentService = /** @class */ (function () {
    function XmentService(xment) {
        this._xment = xment;
        this.getXmentVariation = this.getXmentVariation.bind(this);
        this.isXmentVariationOn = this.isXmentVariationOn.bind(this);
        this.isNoStoreXmentOn = this.isNoStoreXmentOn.bind(this);
    }
    XmentService.prototype.getXmentVariation = function (xmentName) {
        var _a;
        return (_a = this._xment) === null || _a === void 0 ? void 0 : _a[xmentName];
    };
    XmentService.prototype.isXmentVariationOn = function (xmentName) {
        var variation = this.getXmentVariation(xmentName);
        if (variation === "ON") {
            return true;
        }
        else if (variation === "OFF") {
            return false;
        }
        else if (typeof variation === "number") {
            return variation > 0;
        }
        else if (typeof variation === "string") {
            try {
                return parseInt(variation, 10) > 0;
            }
            catch (_) {
                return false;
            }
        }
        return false;
    };
    XmentService.prototype.isNoStoreXmentOn = function (xmentName) {
        var variation = this.getXmentVariation(xmentName);
        return variation === 1 || variation === "1";
    };
    return XmentService;
}());
exports.XmentService = XmentService;
//# sourceMappingURL=XmentService.js.map